import { Component, OnInit, HostListener } from '@angular/core';
import { Chart } from 'angular-highcharts';
import { Router } from '@angular/router';
import { ResidentialService } from '../residential.service';
import * as _ from 'underscore';

@Component({
  selector: 'app-recommendation',
  templateUrl: './recommendation.component.html',
  styleUrls: ['./recommendation.component.css']
})
export class RecommendationComponent implements OnInit {
  constructor(private router: Router, private residentialService: ResidentialService) {
    window.onbeforeunload = function(e) {
        alert('By refreshing this page you may lost all data.');
        return 'Dialog text here.';
      };
   }

  ngOnInit() {
  }
  // To handle the page close or reload event - After questionnarie
  @HostListener('window:beforeunload', ['$event'])
  // canDeactivate(): Observable<boolean> | boolean {
  //   if (this.residentialService.user) {
  //     return true;
  //   } else {
  //     return false;
  //   }
  // }
  beforeunloadHandler($event) {
    alert('By refreshing this page you may lost all data.');
    $event.returnValue = false;
    // const serviceObj = _.findWhere(this.residentialService.userResponse.userResponses, { 'res_question_id': '002' });
    // if (_.isEmpty(sessionStorage.getItem('userObj'))) {
      const questionObj = {
        'questionStatus': 'Completed',
        'questionStep': this.residentialService.currentId,
        'type': this.residentialService.service,
        'percentage': 100,
        'enrollmentState': 'Quitted'
      };
      sessionStorage.setItem('questionStatusObj', JSON.stringify(questionObj));
      setTimeout(() => {
        // return this.router.navigateByUrl('/skippage');
        return this.residentialService.quitFlow();
      }, 50);
    // }
  }
}
